import React from "react";
import { MapContainer, TileLayer, useMap, Marker, Popup } from "react-leaflet";
import L from "leaflet";

export default function Map(params) {
    const Red_MARKER = `data:image/svg+xml;utf8,${encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512" fill="red"><title>Location</title><circle cx="256" cy="192" r="32"/><path d="M256 32c-88.22 0-160 68.65-160 153 0 40.17 18.31 93.59 54.42 158.78 29 52.34 62.55 99.67 80 123.22a31.75 31.75 0 0051.22 0c17.42-23.55 51-70.88 80-123.22C397.69 278.61 416 225.19 416 185c0-84.35-71.78-153-160-153zm0 224a64 64 0 1164-64 64.07 64.07 0 01-64 64z"/></svg>`
    )}`;

    const BoatIcon = L.icon({
        iconUrl: Red_MARKER,
        iconSize: [40, 40],
        iconAnchor: [12, 12],
        popupAnchor: [0, 0],
    });
    let pointsOnMap = params.stateData.mapPoints.map((ele) => {
        return (
            <Marker position={[ele.latitude, ele.longitude]} icon={BoatIcon}>
                <Popup
                    class="request-popup"
                    style={{ backgroundColor: "red" }}
                >{` ${ele.note}`}</Popup>
            </Marker>
        );
    });
    return (
        <MapContainer
            key={
                params.stateData.mapData.url +
                params.stateData.mapData.center +
                params.stateData.mapData.length
            }
            center={params.stateData.mapData.center}
            zoom={params.stateData.mapData.zoom}
            scrollWheelZoom={true}
            className="map"
        >
            <TileLayer
                attribution={params.stateData.mapData.attribution}
                url={params.stateData.mapData.url}
            />
            {/* <Marker position={[30, 78]}>
                <Popup>
                    A pretty CSS3 popup. <br /> Easily customizable.
                </Popup>
            </Marker> */}
            {pointsOnMap}
        </MapContainer>
    );
}
